import React from "react"

export default function IeBanner() {
    return (
        <div className="ie-info">
            For best experience please use a modern browser (Firefox, Chrome or Safari)
        </div>
    )
}